/**
 * React Query hook for Health Check API.
 * IP-012: GET /api/health — auto-refetch every 60s.
 */

import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "@/providers/api-provider";
import type { HealthStatus } from "@/types";

export function useHealth() {
  const api = useApiClient();

  return useQuery({
    queryKey: ["health"],
    queryFn: () => api.get<HealthStatus>("/api/health"),
    staleTime: 60_000,
    refetchInterval: 60_000,
    retry: 2,
  });
}
